// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Brand model hasMany relations 1`] = `
Array [
  "Flag",
]
`;
